/**
 * Stage colour swatches (matches the seeded defaults) and kind presentation.
 */
import type { StageKind } from '@/features/pipeline/types';

export const STAGE_COLORS: ReadonlyArray<{ hex: string; name: string }> = [
  { hex: '#71717a', name: 'Slate' },
  { hex: '#0ea5e9', name: 'Sky' },
  { hex: '#6366f1', name: 'Indigo' },
  { hex: '#8b5cf6', name: 'Violet' },
  { hex: '#f59e0b', name: 'Amber' },
  { hex: '#14b8a6', name: 'Teal' },
  { hex: '#22c55e', name: 'Green' },
  { hex: '#ef4444', name: 'Red' },
  { hex: '#16a34a', name: 'Forest' },
  { hex: '#ec4899', name: 'Pink' },
  { hex: '#1B3A5C', name: 'Navy' },
];

export const DEFAULT_STAGE_COLOR = '#71717a';

export const STAGE_KINDS: ReadonlyArray<{ value: StageKind; label: string; hint: string }> = [
  { value: 'open', label: 'Open', hint: 'Still in play' },
  { value: 'won', label: 'Won', hint: 'Hired — the goal' },
  { value: 'lost', label: 'Lost', hint: 'Out of the running' },
];

export function kindLabel(kind: StageKind): string {
  return STAGE_KINDS.find((k) => k.value === kind)?.label ?? kind;
}

/** Column header tint: won = green wash, lost = muted red, open = stage colour as a top bar. */
export function columnHeaderClass(kind: StageKind): string {
  if (kind === 'won') return 'bg-success-bg/70 border-success/20';
  if (kind === 'lost') return 'bg-danger-bg/60 border-danger/15';
  return 'bg-white border-gray-200';
}
